// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
.wn-card {
  border-radius: 16px;
  background: #fff;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.wn-sop-alerts .wn-sop-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 10px 16px;
  background: #fef2f2;
  border-bottom: 1px solid #ededed;
  color: #dc2626;
  font-size: 0.82rem;
  font-weight: 600;
}
.wn-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f0f4ff 0%, #f8f6ff 100%);
  border-bottom: 1px solid rgba(0, 95, 240, 0.08);
}
.wn-source-tag {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #005ff0;
}
.wn-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  transition: transform 120ms ease, box-shadow 120ms ease;
}
.wn-status-badge:hover {
  transform: scale(1.04);
}
.wn-status-badge.status-active {
  background: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15);
}
.wn-status-badge.status-inactive {
  background: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);
}
.wn-status-badge.status-other {
  background: #a3a3a3;
}
.wn-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 16px;
}
.wn-hero-left {
  flex: 1;
  min-width: 0;
}
.wn-employer-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.3;
}
.wn-applicant-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 6px;
  font-size: 0.78rem;
  color: #a3a3a3;
}
.wn-name-match {
  font-size: 1rem;
  line-height: 1;
  margin-top: 2px;
}
.wn-match-yes {
  color: #16a34a;
}
.wn-match-no {
  color: #dc2626;
}
.wn-name-rows {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.wn-name-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.wn-applicant-label {
  font-weight: 600;
  color: #a3a3a3;
  font-size: 0.72rem;
}
.wn-applicant-value {
  font-weight: 700;
  color: #171717;
  font-size: 0.82rem;
}
.wn-hero-right {
  flex-shrink: 0;
  text-align: right;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
  border-radius: 6px;
  border: 1px solid rgba(22, 163, 74, 0.12);
}
.wn-hero-amount {
  font-size: 1.65rem;
  font-weight: 800;
  color: #16a34a;
  line-height: 1.1;
  letter-spacing: -0.02em;
}
.wn-hero-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-top: 1px;
}
.wn-hero-annual {
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #a3a3a3;
}
.wn-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  padding: 0 16px 14px;
}
.wn-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fafafa;
  transition: background 120ms ease;
}
.wn-stat:hover {
  background: #f5f5f5;
}
.wn-stat-pay-period {
  grid-column: 1;
  grid-row: 2;
}
.wn-stat-ref {
  grid-column: 2;
  grid-row: 2;
}
.wn-stat-icon {
  font-size: 1.1rem;
  line-height: 1;
  flex-shrink: 0;
}
.wn-stat-body {
  min-width: 0;
}
.wn-stat-label {
  font-size: 0.62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
}
.wn-stat-value {
  font-size: 0.82rem;
  font-weight: 700;
  color: #171717;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wn-stat-value-ref {
  -webkit-user-select: all;
          user-select: all;
  font-variant-numeric: tabular-nums;
}
.wn-quality-ring {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.wn-ring-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}
.wn-ring-bg {
  fill: none;
  stroke: #ededed;
  stroke-width: 3;
}
.wn-ring-fill {
  fill: none;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dasharray 600ms ease-out;
}
.wn-ring-fill.wn-ring-full {
  stroke: #16a34a;
}
.wn-ring-fill.wn-ring-mid {
  stroke: #ea580c;
}
.wn-ring-fill.wn-ring-low {
  stroke: #dc2626;
}
.wn-more-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #005ff0;
  cursor: pointer;
  border-top: 1px solid #ededed;
  transition: background 120ms ease;
  -webkit-user-select: none;
          user-select: none;
}
.wn-more-toggle:hover {
  background: #fafafa;
}
.wn-toggle-chevron {
  display: inline-block;
  font-size: 0.7rem;
  transition: transform 200ms ease;
}
.wn-toggle-chevron.wn-toggle-open {
  transform: rotate(90deg);
}
.wn-more-body {
  padding: 14px 16px 16px;
  border-top: 1px solid #ededed;
  background: #fafafa;
}
.wn-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.wn-detail-item {
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #ededed;
}
.wn-detail-item-label {
  font-size: 0.62rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-bottom: 2px;
}
.wn-detail-item-value {
  font-size: 0.88rem;
  font-weight: 700;
  color: #171717;
}
.wn-detail-item-value small {
  font-size: 0.7rem;
  font-weight: 400;
  color: #a3a3a3;
  margin-left: 2px;
}
.wn-comp-history {
  margin-top: 4px;
}
.wn-comp-title {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-bottom: 8px;
}
.wn-comp-bars {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.wn-comp-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #ededed;
  transition: background 120ms ease;
}
.wn-comp-row:hover {
  background: #f5f5f5;
}
.wn-comp-year {
  font-size: 0.8rem;
  font-weight: 600;
  color: #171717;
}
.wn-comp-amount {
  font-size: 0.85rem;
  font-weight: 700;
  color: #005ff0;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/work-number-wizard-detail.component.less"],"names":[],"mappings":"AAeA;EACE,cAAA;EACA,WAAA;AAdF;AAkBA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yEAAA;EACA,gBAAA;EACA,sBAAA;AAhBF;AAoBA;EAEI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAnBJ;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,+CAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAvBF;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,uDAAA;AAxBF;AA0BE;EACE,sBAAA;AAxBJ;AA2BE;EACE,mBAAA;EACA,6CAAA;AAzBJ;AA4BE;EACE,mBAAA;EACA,6CAAA;AA1BJ;AA6BE;EACE,mBAAA;AA3BJ;AAgCA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AA9BF;AAiCA;EACE,OAAA;EACA,YAAA;AA/BF;AAkCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAhCF;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAjCF;AAoCA;EAAiB,eAAA;EAAiB,cAAA;EAAgB,eAAA;AA/BlD;AAgCA;EAAgB,cAAA;AA7BhB;AA8BA;EAAe,cAAA;AA3Bf;AA4BA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAvBvD;AAwBA;EAAe,aAAA;EAAe,qBAAA;EAAuB,QAAA;AAnBrD;AAoBA;EAAsB,gBAAA;EAAkB,cAAA;EAAwB,kBAAA;AAfhE;AAgBA;EAAsB,gBAAA;EAAkB,cAAA;EAAyB,kBAAA;AAXjE;AAaA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;EACA,yCAAA;AAXF;AAcA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAZF;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAbF;AAgBA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAdF;AAkBA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,oBAAA;AAhBF;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;AAjBF;AAmBE;EACE,mBAAA;AAjBJ;AAqBA;EACE,cAAA;EACA,WAAA;AAnBF;AAsBA;EACE,cAAA;EACA,WAAA;AApBF;AAuBA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;AArBF;AAwBA;EACE,YAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAvBF;AA0BA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxBF;AA2BA;EACE,wBAAA;UAAA,gBAAA;EACA,kCAAA;AAzBF;AA6BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AA3BF;AA8BA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AA5BF;AA+BA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AA7BF;AAgCA;EACE,UAAA;EACA,eAAA;EACA,qBAAA;EACA,2CAAA;AA9BF;AAgCE;EACE,eAAA;AA9BJ;AAiCE;EACE,eAAA;AA/BJ;AAkCE;EACE,eAAA;AAhCJ;AAqCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,iCAAA;EACA,yBAAA;UAAA,iBAAA;AAnCF;AAqCE;EACE,mBAAA;AAnCJ;AAuCA;EACE,qBAAA;EACA,iBAAA;EACA,gCAAA;AArCF;AAuCE;EACE,wBAAA;AArCJ;AAyCA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;AAvCF;AA2CA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,mBAAA;AAzCF;AA4CA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA1CF;AA6CA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AA3CF;AA8CA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AA5CF;AAyCA;EAMI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA5CJ;AAiDA;EACE,eAAA;AA/CF;AAkDA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAhDF;AAmDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjDF;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iCAAA;AAlDF;AAoDE;EACE,mBAAA;AAlDJ;AAsDA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AApDF;AAuDA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AArDF","sourcesContent":["// UDS-inspired tokens (sourced from iiq-urban-design-engineering)\n@uds-blue-70: #005ff0;\n@uds-blue-60: #0480fc;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-orange-70: #ea580c;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius-lg: 16px;\n@uds-radius-sm: 6px;\n@uds-transition: 120ms ease;\n\n:host {\n  display: block;\n  width: 100%;\n}\n\n// ── Card shell ──\n.wn-card {\n  border-radius: @uds-radius-lg;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n\n// ── SOP alert banners ──\n.wn-sop-alerts {\n  .wn-sop-alert {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 10px 16px;\n    background: #fef2f2;\n    border-bottom: 1px solid @uds-neutral-30;\n    color: @uds-red-70;\n    font-size: 0.82rem;\n    font-weight: 600;\n  }\n}\n\n// ── Header band ──\n.wn-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #f0f4ff 0%, #f8f6ff 100%);\n  border-bottom: 1px solid rgba(0, 95, 240, 0.08);\n}\n\n.wn-source-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: @uds-blue-70;\n}\n\n.wn-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #fff;\n  transition: transform @uds-transition, box-shadow @uds-transition;\n\n  &:hover {\n    transform: scale(1.04);\n  }\n\n  &.status-active {\n    background: @uds-green-70;\n    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15);\n  }\n\n  &.status-inactive {\n    background: @uds-red-70;\n    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);\n  }\n\n  &.status-other {\n    background: @uds-neutral-50;\n  }\n}\n\n// ── Hero section ──\n.wn-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 16px;\n}\n\n.wn-hero-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.wn-employer-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n}\n\n.wn-applicant-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 6px;\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n}\n\n.wn-name-match { font-size: 1rem; line-height: 1; margin-top: 2px; }\n.wn-match-yes { color: @uds-green-70; }\n.wn-match-no { color: @uds-red-70; }\n.wn-name-rows { display: flex; flex-direction: column; gap: 1px; }\n.wn-name-row { display: flex; align-items: baseline; gap: 5px; }\n.wn-applicant-label { font-weight: 600; color: @uds-neutral-50; font-size: 0.72rem; }\n.wn-applicant-value { font-weight: 700; color: @uds-neutral-100; font-size: 0.82rem; }\n\n.wn-hero-right {\n  flex-shrink: 0;\n  text-align: right;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);\n  border-radius: @uds-radius-sm;\n  border: 1px solid rgba(22, 163, 74, 0.12);\n}\n\n.wn-hero-amount {\n  font-size: 1.65rem;\n  font-weight: 800;\n  color: @uds-green-70;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.wn-hero-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-top: 1px;\n}\n\n.wn-hero-annual {\n  margin-top: 4px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-neutral-50;\n}\n\n// ── Stats grid (4 cols): row2 Pay Period + Ref align under Hired / Last Checked ──\n.wn-stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 6px;\n  padding: 0 16px 14px;\n}\n\n.wn-stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 8px 12px;\n  border-radius: @uds-radius-sm;\n  background: @uds-neutral-10;\n  transition: background @uds-transition;\n\n  &:hover {\n    background: @uds-neutral-20;\n  }\n}\n\n.wn-stat-pay-period {\n  grid-column: 1;\n  grid-row: 2;\n}\n\n.wn-stat-ref {\n  grid-column: 2;\n  grid-row: 2;\n}\n\n.wn-stat-icon {\n  font-size: 1.1rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.wn-stat-body {\n  min-width: 0;\n}\n\n.wn-stat-label {\n  font-size: 0.62rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n}\n\n.wn-stat-value {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wn-stat-value-ref {\n  user-select: all;\n  font-variant-numeric: tabular-nums;\n}\n\n// ── Data quality ring ──\n.wn-quality-ring {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n}\n\n.wn-ring-svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.wn-ring-bg {\n  fill: none;\n  stroke: @uds-neutral-30;\n  stroke-width: 3;\n}\n\n.wn-ring-fill {\n  fill: none;\n  stroke-width: 3;\n  stroke-linecap: round;\n  transition: stroke-dasharray 600ms ease-out;\n\n  &.wn-ring-full {\n    stroke: @uds-green-70;\n  }\n\n  &.wn-ring-mid {\n    stroke: @uds-orange-70;\n  }\n\n  &.wn-ring-low {\n    stroke: @uds-red-70;\n  }\n}\n\n// ── Expandable detail ──\n.wn-more-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 16px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: @uds-blue-70;\n  cursor: pointer;\n  border-top: 1px solid @uds-neutral-30;\n  transition: background @uds-transition;\n  user-select: none;\n\n  &:hover {\n    background: @uds-neutral-10;\n  }\n}\n\n.wn-toggle-chevron {\n  display: inline-block;\n  font-size: 0.7rem;\n  transition: transform 200ms ease;\n\n  &.wn-toggle-open {\n    transform: rotate(90deg);\n  }\n}\n\n.wn-more-body {\n  padding: 14px 16px 16px;\n  border-top: 1px solid @uds-neutral-30;\n  background: @uds-neutral-10;\n}\n\n// ── Detail grid ──\n.wn-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.wn-detail-item {\n  padding: 8px 10px;\n  border-radius: @uds-radius-sm;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n}\n\n.wn-detail-item-label {\n  font-size: 0.62rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-bottom: 2px;\n}\n\n.wn-detail-item-value {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n\n  small {\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: @uds-neutral-50;\n    margin-left: 2px;\n  }\n}\n\n// ── Comp history ──\n.wn-comp-history {\n  margin-top: 4px;\n}\n\n.wn-comp-title {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-bottom: 8px;\n}\n\n.wn-comp-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.wn-comp-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px;\n  border-radius: @uds-radius-sm;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  transition: background @uds-transition;\n\n  &:hover {\n    background: @uds-neutral-20;\n  }\n}\n\n.wn-comp-year {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: @uds-neutral-100;\n}\n\n.wn-comp-amount {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: @uds-blue-70;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
